import Vue from "vue";
import Router from "vue-router";
import { i18n } from "@/i18n";
import store from "@/store/store";
import LangPart from "@/components/views/LangPart";
import Home from "@/components/views/home/home";
const Actualidad = () => import("@/components/views/actualidad");
const FichaNoticia = () => import("@/components/views/ficha-noticia");

const promociones = () => import("@/components/views/promociones");
const FichaPromocion = () => import("@/components/views/ficha-promocion");
const basesLegalesPromocion = () =>
  import("@/components/views/bases-legales-promo");

const pressroom = () => import("@/components/views/pressroom");
const faqs = () => import("@/components/views/faqs");
const distribuidores = () => import("@/components/views/distribuidores");
const historia = () => import("@/components/views/historia");
const nutririsi = () => import("@/components/views/nutririsi");
const quienessomos = () => import("@/components/views/quienes-somos");

const Contacto = () => import("@/components/views/contacto");
const ContactoForm = () => import("@/components/views/contacto-form");

const Error404 = () => import("@/components/views/error-404");

const politica_cookies = () => import("@/components/views/politica-de-cookies");
const politica_privacidad = () =>
  import("@/components/views/politica-de-privacidad");
const aviso_legal = () => import("@/components/views/aviso-legal");
const bases_legales_risi = () =>
  import("@/components/views/bases-legales-risi");
const regulatory_compliance = () =>
  import("@/components/views/cumplimiento-normativo/regulatory-compliance");
const values = () => import("@/components/views/cumplimiento-normativo/values");
const ethical_channel = () =>
  import("@/components/views/cumplimiento-normativo/ethical-channel");
const sustainability = () =>
  import("@/components/views/cumplimiento-normativo/sustainability");

const cartapresidente = () =>
  import("@/components/views/codigo-conducta/carta-del-presidente");
const risiempleados = () =>
  import("@/components/views/codigo-conducta/risi-y-empleados");
const risiproveedores = () =>
  import("@/components/views/codigo-conducta/risi-y-proveedores");
const risisociedad = () =>
  import("@/components/views/codigo-conducta/risi-y-sociedad");
const daganzo = () => import("@/components/views/codigo-conducta/daganzo");
const loeches = () => import("@/components/views/codigo-conducta/loeches");
const matarile = () => import("@/components/views/codigo-conducta/matarile");
const risiconsumidores = () =>
  import("@/components/views/codigo-conducta/risi-y-consumidores");
const cumplimientoetico = () =>
  import("@/components/views/codigo-conducta/cumplimiento-etico");
const principiosgenerales = () =>
  import("@/components/views/codigo-conducta/principios-generales");
const codigoconducta = () =>
  import("@/components/views/codigo-conducta/codigo-conducta");

const materialesprensa = () => import("@/components/views/materiales-prensa");

const concursofulloftrickers = () =>
  import("@/components/views/concurso-full-of-trickers");
const basesconcursofulloftrickers = () =>
  import("@/components/views/bases-legales-full-of-trickers");

//SNAKS

const snacks = () => import("@/components/views/snacks/snacks");
const otrosproductos = () =>
  import("@/components/views/snacks/otros-productos");
const gusanitos = () => import("@/components/views/snacks/gusanitos");
const matchball = () => import("@/components/views/snacks/match-ball");
const jummy = () => import("@/components/views/snacks/jummy");
const mios = () => import("@/components/views/snacks/mios");
const palomitas = () => import("@/components/views/snacks/palomitas");
const risketos = () => import("@/components/views/snacks/risketos");
const triskys = () => import("@/components/views/snacks/triskys");
const exportacion = () => import("@/components/views/patatas/exportacion");

const homepatatas = () => import("@/components/views/patatas/patatas");
const originales = () => import("@/components/views/patatas/originales");
const onduladas = () => import("@/components/views/patatas/onduladas");
const selectas = () => import("@/components/views/patatas/selectas");
const detodalavida = () => import("@/components/views/patatas/toda-la-vida");

const galletas = () => import("@/components/views/galletas/galletas");
const bsan = () => import("@/components/views/galletas/galletas-bsan");
const maria = () => import("@/components/views/galletas/maria");
const adultas = () => import("@/components/views/galletas/adultas");
const plus = () => import("@/components/views/galletas/plus");
const fabs = () => import("@/components/views/galletas/fabs");

const chocolate = () => import("@/components/views/galletas/chocolate");
const desayuno = () => import("@/components/views/galletas/desayuno");
const premium = () => import("@/components/views/galletas/premium");
const infantiles = () => import("@/components/views/galletas/infantiles");
const tradicionales = () => import("@/components/views/galletas/tradicionales");

const caramelos = () => import("@/components/views/caramelos/caramelos");
const caramelosTradicionales = () =>
  import("@/components/views/caramelos/tradicionales");
const caramelos0Azucares = () =>
  import("@/components/views/caramelos/0-azucares");

const borges = () => import("@/components/views/borges/borges");
const frutosecos = () => import("@/components/views/borges/frutos-secos");
const pipas = () => import("@/components/views/borges/pipas");
const natura = () => import("@/components/views/borges/natura");
Vue.use(Router);
import messages from "@/translations";

let routes = [
  {
    path: "/:lang(es|en|fr)?",
    name: "language-part",
    component: LangPart,
    children: [
      //STATIC
      {
        alias: `/home`,
        name: "home",
        component: Home
      },
      {
        name: "noticias",
        component: Actualidad
        // meta: {
        //   idParameter: true,
        // }
      },

      {
        name: "noticia",
        component: FichaNoticia,
        meta: {
          idParameter: true
        }
      },
      {
        name: "contacto",
        component: Contacto
      },
      {
        name: "contacto",
        component: ContactoForm,
        meta: {
          idParameter: true
        }
      },
      {
        name: "promociones",
        // component: promociones,
        component: promociones
      },
      {
        name: "promociones",
        // component: promociones,
        component: FichaNoticia
      },
      {
        name: "faqs",
        component: faqs
      },
      {
        name: "nutririsi",
        component: nutririsi
      },
      {
        name: "historia",
        component: historia
      },
      {
        name: "quienessomos",
        component: quienessomos
      },
      {
        name: "pressroom",
        component: pressroom
      },
      {
        name: "distribuidores",
        component: distribuidores
      },
      {
        name: "snacks",
        component: snacks
      },

      {
        name: "otrosProductos",
        component: otrosproductos,
        meta: {
          idParameter: true,
          familia: "snacks"
        }
      },
      {
        name: "gusanitos",
        component: gusanitos,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "matchBall",
        component: matchball,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "jummy",
        component: jummy,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "mios",
        component: mios,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "palomitas",
        component: palomitas,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "risketos",
        component: risketos,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "triskys",
        component: triskys,
        meta: {
          familia: "snacks"
        }
      },
      {
        name: "exportacion",
        component: exportacion,
        meta: {
          familia: "patatas"
        }
      },
      {
        name: "galletas",
        component: galletas
      },
      {
        name: "bsan",
        component: bsan,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "chocolate",
        component: chocolate,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "maria",
        component: maria,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "adultas",
        component: adultas,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "desayuno",
        component: desayuno,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "infantiles",
        component: infantiles,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "tradicionales",
        component: tradicionales,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "plus",
        component: plus,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "fabs",
        component: fabs,
        meta: {
          familia: "galletas"
        }
      },
      {
        name: "azucares0",
        component: caramelos0Azucares,
        meta: {
          familia: "caramelos"
        }
      },
      {
        name: "caramelosTradicionales",
        component: caramelosTradicionales,
        meta: {
          familia: "caramelos"
        }
      },
      {
        name: "borges",
        component: borges
      },
      {
        name: "caramelos",
        component: caramelos
      },
      {
        name: "frutossecos",
        component: frutosecos,
        meta: {
          familia: "frutos-secos"
        }
      },
      {
        name: "pipas",
        component: pipas,
        meta: {
          familia: "frutos-secos"
        }
      },
      {
        name: "promocion",
        component: FichaPromocion,
        meta: {
          idParameter: true
        }
      },
      {
        name: "basesLegalesPromocion",
        component: basesLegalesPromocion,
        meta: {
          idParameter: true
        }
      },
      {
        name: "codigoconducta",
        component: codigoconducta,
        meta: {
          regulatorycompliance: true
        }
      },
      {
        name: "cartapresidente",
        component: cartapresidente,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "risiempleados",
        component: risiempleados,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "risiproveedores",
        component: risiproveedores,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "risisociedad",
        component: risisociedad,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "daganzo",
        component: daganzo
      },
      {
        name: "loeches",
        component: loeches
      },
      {
        name: "patatas",
        component: homepatatas
      },
      {
        name: "originales",
        component: originales,
        meta: {
          familia: "patatas"
        }
      },
      {
        name: "onduladas",
        component: onduladas,
        meta: {
          familia: "patatas"
        }
      },
      {
        name: "selectas",
        component: selectas,
        meta: {
          familia: "patatas"
        }
      },
      {
        name: "detodalavida",
        component: detodalavida,
        meta: {
          familia: "patatas"
        }
      },
      {
        name: "matarile",
        component: matarile
      },
      {
        name: "cumplimientoetico",
        component: cumplimientoetico,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "risiconsumidores",
        component: risiconsumidores,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "principiosgenerales",
        component: principiosgenerales,
        meta: {
          incodigoconducta: true
        }
      },
      {
        name: "materialesprensa",
        component: materialesprensa
      },
      {
        name: "concursofulloftrickers",
        component: concursofulloftrickers
      },
      {
        name: "basesconcursofulloftrickers",
        component: basesconcursofulloftrickers
      },
      {
        name: "politica_privacidad",
        component: politica_privacidad
      },
      {
        name: "politica_cookies",
        component: politica_cookies
      },
      {
        name: "aviso_legal",
        component: aviso_legal
      },
      {
        name: "bases_legales_risi",
        component: bases_legales_risi
      },
      {
        name: "regulatory_compliance",
        component: regulatory_compliance
      },
      {
        name: "values",
        component: values,
        meta: {
          regulatorycompliance: true
        }
      },
      {
        name: "ethical_channel",
        component: ethical_channel,
        meta: {
          regulatorycompliance: true
        }
      },
      {
        name: "sustainability",
        component: sustainability,
        meta: {
          regulatorycompliance: true
        }
      },
      {
        path: "*",
        redirect: "/"
      },
      {
        path: "/404",
        component: Error404
      }
    ]
  }
];

routes[0].children.forEach(function(value, key) {
  if (value.path == null) {
    value.path = i18n.t("enlaces." + value.name);
    value.alias = [];
    value.meta = value.meta ? value.meta : {};
    value.meta.seo = value.meta.seo ? value.meta.seo : {};
    Object.keys(messages).forEach(function(lang) {
      if (value.meta.seo[lang] == null) {
        value.meta.seo[lang] = messages[lang].enlaces.seo[value.name];
      }

      if (
        messages[lang].enlaces[value.name] != null &&
        messages[lang].enlaces[value.name] != value.path &&
        value.alias.includes(messages[lang].enlaces[value.name]) == false
      ) {
        value.alias.push(messages[lang].enlaces[value.name]);
      }
    });
    if (value.meta.idParameter) {
      value.path += "/:id?";
      value.alias.forEach(function(alia, index) {
        value.alias[index] += "/:id?";
      });
    }
  }
});
const router = new Router({
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name == "otrosProductos") {
      to.params.id = "#" + to.params.id;
    }

    if (to.params.id) {
      return {
        selector: to.params.id,
        behavior: "smooth",
        block: "start"
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.params.lang == null) {
    to.params.lang = store.getters.getLanguage
      ? store.getters.getLanguage
      : i18n.locale;
    next({
      path: to.params.lang + "/" + i18n.t("enlaces." + to.name),
      name: to.name ? to.name : "home",
      params: to.params
    });
    return;
  }
  if (to.params.lang && to.params.lang != store.getters.getLanguage) {
    let lang = to.params.lang;
    store.dispatch("changeLanguage", lang);
  }

  let explode = to.path.split("/");

  if (to.name && to.name != "home" && explode.length > 2) {
    explode.shift();
    explode.shift();
    if (to.meta.idParameter && to.params.id) {
      explode.pop();
    }
    explode = explode.join("/");
    if (explode != i18n.t("enlaces." + to.name)) {
      //Yeah...risky as hell
      let url = "/" + to.params.lang + "/" + i18n.t("enlaces." + to.name);
      if (to.params.id) {
        url += "/" + to.params.id;
      }
      next(url);
      return;
    }
  }

  let meta = to.meta.seo ? to.meta.seo[to.params.lang] : null;
  if (!!meta && !!meta.description) {
    document.title = meta.title;
    document.head.querySelector("[property='og:title']").content = meta.title;
    document.head.querySelector("[name=description]").content =
      meta.description;
    document.head.querySelector("[property='og:description']").content =
      meta.description;
    document.head.querySelector("[property='og:url']").content = location.href;
  }

  /*   if (window.location.host === 'risi.dev.doubledot.es') {
    document.head.querySelector("[name=chatBot]").src = '//code.tidio.co/4kk3d6clxrswvtgw9egig3l406ejcu7j.js';
  } */

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js